import { Stack } from 'expo-router';
import { View } from 'react-native';

import { MemberWebNavigation } from '@/components/member-web-navigation';

export default function GlobalAppTabsWebLayout() {
  return (
    <View className="flex-1 bg-background">
      <MemberWebNavigation />
      <View className="flex-1">
        <Stack screenOptions={{ headerShown: false }} />
      </View>
    </View>
  );
}
